import React, {FC} from 'react';

import {DraftMessageModel} from '../../../../../libs/shared/core/src/models/api/messageModel';
import {CellsContext} from '../../../../../libs/shared/core/src/store/panels/cells/context/cellsContext';
import {ViewerPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {TimelineVariationsEnum} from '../../../../../libs/shared/core/src/store/timelineVariations/timelineVariationsTypes';
import {ConversationModel} from '../../../../models/api/conversationModel';
import {ComposerContainer} from '../../composer/composerContainer';
import {ComposerErrorBoundary} from '../../composer/composerErrorBoundary';
import {MessageViewerBase} from '../activity/message/messageViewerBase';

/*
 * Props.
 */

interface MessageComposerProps {
  panelId: ViewerPanelId;
  message: DraftMessageModel;
  cellsContext: CellsContext;
  dontFocusComposer?: boolean;
  conversation: ConversationModel;
  isFirst?: boolean;
  isOnlyComposer: boolean;
  isShared?: boolean;
  timelineVariation: TimelineVariationsEnum;
  canPopout: boolean;
}

/*
 * Component.
 */

export const MessageComposer: FC<MessageComposerProps> = (props) => (
  <MessageViewerBase
    interactionId={props.isShared ? 'message-composer-shared' : 'message-composer'}
    isFirst={props.isFirst}
    timelineVariation={TimelineVariationsEnum.ASYNCHRONOUS}
  >
    <ComposerErrorBoundary message={props.message} timelineVariation={props.timelineVariation}>
      <ComposerContainer {...props} shouldDynamicallyGrowComposer />
    </ComposerErrorBoundary>
  </MessageViewerBase>
);
